import { ColumnSizingState, type Table as ReactTable } from '@tanstack/react-table';
import { useEffect, useState } from 'react';

import { useDebounceCallback } from './useDebounceCallback';

const getTableColumnSizes = (): Record<string, number> =>
  JSON.parse(window.localStorage.getItem('cradl:tableColumnSizes') || '{}');

type UseAutoSaveColumnSizesProps<T> = {
  table?: ReactTable<T>;
  enabled?: boolean;
};

export function useAutoSaveColumnSizes<T>(opts?: UseAutoSaveColumnSizesProps<T>) {
  const { table, enabled } = opts ?? {};

  const [tableColumnSizes, setTableColumnSizes] = useState(getTableColumnSizes());
  const columnSizing = table?.getState().columnSizing;

  const updateColumnSizes = useDebounceCallback((columnSizing: ColumnSizingState) => {
    const updates = getTableColumnSizes();
    for (const [column, sz] of Object.entries(columnSizing)) {
      updates[column] = sz;
    }

    window.localStorage.setItem('cradl:tableColumnSizes', JSON.stringify(updates));
    setTableColumnSizes(updates);
  }, 200);

  useEffect(() => {
    if (enabled && columnSizing) {
      updateColumnSizes(columnSizing);
    }
  }, [columnSizing, enabled, updateColumnSizes]);

  return { tableColumnSizes };
}
